/* Scroll infinito de las colecciones: al bajar se añade la página siguiente.
   Los números de página siguen en el HTML (Google los lee) pero se esconden a la vista. */
(function () {
  if (window.__scrollInfinito) return;
  window.__scrollInfinito = true;

  var cargando = false;
  var fin = false;
  var sentinela = null;
  var observador = null;

  var css = document.createElement('style');
  css.textContent =
    '.sinf .pagination-wrapper{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}' +
    '.sinf-estado{text-align:center;padding:2.4rem 1rem;font-size:1.4rem;opacity:.7;min-height:6rem}';
  document.head.appendChild(css);

  function estado() {
    var g = document.getElementById('product-grid');
    var w = document.querySelector('.pagination-wrapper');
    if (!g || !w || g.tagName !== 'UL') return null;
    return { g: g, w: w };
  }

  function ultimaPagina(w) {
    var m = 1;
    var els = w.querySelectorAll('.pagination__item');
    for (var i = 0; i < els.length; i++) {
      var n = parseInt((els[i].textContent || '').trim(), 10);
      if (n > m) m = n;
    }
    return m;
  }

  function paginaActual(e) {
    return parseInt(e.g.getAttribute('data-sinf-pag') || e.w.getAttribute('data-page') || '1', 10);
  }

  function apagar() {
    fin = true;
    document.documentElement.classList.remove('sinf');
    if (sentinela && sentinela.parentNode) sentinela.parentNode.removeChild(sentinela);
  }

  function cargarSiguiente() {
    var e = estado();
    if (!e || cargando || fin) return;
    var actual = paginaActual(e);
    var ultima = ultimaPagina(e.w);
    if (actual >= ultima) {
      if (sentinela) sentinela.textContent = '';
      return;
    }
    cargando = true;
    sentinela.textContent = 'Cargando más…';
    var url = new URL(window.location.href);
    url.searchParams.set('page', actual + 1);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevos = doc.querySelectorAll('#product-grid > li');
        var e2 = estado();
        if (!e2 || e2.g !== e.g) return;
        for (var i = 0; i < nuevos.length; i++) {
          var li = document.importNode(nuevos[i], true);
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          li.removeAttribute('data-cascade');
          e.g.appendChild(li);
        }
        e.g.setAttribute('data-sinf-pag', String(actual + 1));
        sentinela.textContent = '';
        cargando = false;
        if (!nuevos.length) {
          e.g.setAttribute('data-sinf-pag', String(ultima));
        } else {
          comprobar();
        }
      })
      .catch(function () {
        cargando = false;
        apagar();
      });
  }

  function comprobar() {
    if (!sentinela || cargando || fin) return;
    var r = sentinela.getBoundingClientRect();
    if (r.top < window.innerHeight + 900) cargarSiguiente();
  }

  function preparar() {
    if (fin) return;
    var e = estado();
    if (!e) return;
    document.documentElement.classList.add('sinf');
    if (!sentinela) {
      sentinela = document.createElement('div');
      sentinela.className = 'sinf-estado';
      sentinela.setAttribute('aria-live', 'polite');
    }
    if (e.g.nextSibling !== sentinela) {
      e.g.parentNode.insertBefore(sentinela, e.g.nextSibling);
      if (observador) observador.disconnect();
      if ('IntersectionObserver' in window) {
        observador = new IntersectionObserver(function (ents) {
          if (ents[0].isIntersecting) cargarSiguiente();
        }, { rootMargin: '900px 0px' });
        observador.observe(sentinela);
      }
    }
  }

  function iniciar() {
    preparar();
    setInterval(function () { preparar(); comprobar(); }, 1000);
    window.addEventListener('scroll', comprobar, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
